import i18n from "../../../../utils/locale/i18n";
import dialogSkin from "../common/dialog.skin";

const formDialog = {
  "@keyframes shine": {
    to: {
      "background-position": "100% 0",
    },
  },
  ...dialogSkin,
  "form-fields": {
    padding: "0px 10px",
  },
  "form-fields-dialog": {
    "max-height": "calc(100vh - 240px)",
    "overflow-x": "hidden",
    "overflow-y": "auto",
  },
  "@media (max-height: 300px)": {
    "form-fields": {
      "max-height": "none",
    },
  },
  "skeleton-loader": {
    width: "100%",
    height: "15px",
    border: "1px solid rgb(239,239,239)",
    "border-radius": "4px",
    display: "block",
    "background-repeat": "repeat-y",
    "background-size": "50px 500px",
    "background-position": "0 0",
    background:
      "linear-gradient(to right, rgba(239, 239, 239, 0), rgba(239, 239, 239, 0.5) 50%, rgba(239, 239, 239, 0) 80%),rgb(255,255,255)",
    animation: "$shine 2s infinite",
    "animation-delay": "0.3s",
  },
  "form-input-read-only": {
    padding: "7px 0px",
    border: "none",
    "background-color": "var(--gc-input-light-background)",
    "&:focus-visible, &:focus": {
      border: "none",
      outline: "none",
      "background-color": "var(--gc-input-light-background)",
    },
  },
  "form-input": {
    composes: "form-control",
  },
  "form-textarea": {
    composes: "form-control",
    "textarea&": {
      "min-height": "250px",
    },
  },
  "form-select": {
    composes: "form-control form-select",
  },
  "form-checkbox": {
    composes: "form-check-input",
    cursor: "pointer",
    height: "1.5rem !important",
    width: "2.75rem !important",
    borderRadius: "3rem !important",
    backgroundColor: "var(--gc-unchecked-background-color)",
    "&:checked": {
      backgroundColor: "var(--gc-selected-background-color)",
    },
  },
  form: {
    composes: "form-horizontal",
    position: "relative",
  },
  "form-loading": {
    "&:before": {
      display: "block",
      content: `"${i18n.t("loading")}"`,
      opacity: "0.5",
      "font-size": "26px",
      position: "absolute",
      "text-align": "center",
      "z-index": "9999",
      color: "var(--gc-light-background-text-color)",
      background: "var(--gc-light-background)",
      cursor: "default",
      width: "100%",
      height: "100%",
    },
  },
  "full-page-title": {
    background: "var(--gc-dark-background)",
    color: "var(--gc-dark-background-text-color)",
    width: "100%",
    padding: "5px 10px",
    "text-align": "left",
  },
};

export default formDialog;
